// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { UserRole } from "graphql/api";
import { ActionType, IAction, IActionSortTable, raiseAction } from "actions";
import { MainPanel } from "types";
import { IState } from "states/states";

import InputList from "view/comp/InputList";
import OutputList from "view/comp/OutputList";
import ModalInput from "view/modal/ModalInput";
import ModalOutput from "view/modal/ModalOutput";

// uses webpack definitions
declare const IS_CLOUD: boolean;

interface IIOsProps {
  hasInputWriteAccess: boolean;
  hasOutputWriteAccess: boolean;
  hasInputs: boolean;
  hasOutputs: boolean;
  showModulesLink: boolean;
}

const mapStateToProps = (state: IState) => {
  const curUser = state.site.userList?.find((curItem) => curItem.secId === state.site.user?.secId);
  const inputCount =
    state.parameter?.input?.filter((input) => {
      return input.webActive;
    }).length ?? 0;
  const outputCount =
    state.parameter?.output?.filter((curItem) => {
      return curItem.webActive;
    }).length ?? 0;

  const props: IIOsProps = {
    hasInputWriteAccess:
      (!IS_CLOUD && state.site.user?.secId === "admin") ||
      (IS_CLOUD && (curUser?.accessRights.setVirtualInputs ?? false)),
    hasOutputWriteAccess:
      (!IS_CLOUD && state.site.user?.secId === "admin") ||
      (IS_CLOUD && (curUser?.accessRights.switchOutputs ?? false)),
    hasInputs: inputCount > 0,
    hasOutputs: outputCount > 0,
    showModulesLink:
      Boolean(curUser?.accessRights.controllerAdmin) && Boolean(state.parameter?.module.length),
  };
  return props;
};

interface IIOsDispatch {
  onSort: (sort: IActionSortTable) => void;
}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IIOsDispatch = {
    onSort: (sort: IActionSortTable) => {
      dispatch(raiseAction(ActionType.ACT_SORT_TABLE, sort));
    },
  };
  return dispatchProps;
};

class IOsComponent extends React.Component<IIOsProps & IIOsDispatch> {
  public render() {
    return (
      <>
        <div id="ios">
          {(this.props.hasInputs || !this.props.hasOutputs) && (
            <InputList isEditable={this.props.hasInputWriteAccess} isDashboard={false} />
          )}
          {(this.props.hasOutputs || !this.props.hasInputs) && (
            <OutputList isEditable={this.props.hasOutputWriteAccess} isDashboard={false} />
          )}
          {this.props.showModulesLink && this.renderModulesLink()}
        </div>
        <ModalInput />
        <ModalOutput />
      </>
    );
  }

  private renderModulesLink() {
    return (
      <div className="mt-3">
        <FormattedMessage id="Click here to see the list of modules and conditions" />:
        <Link to={`../${MainPanel.MODULES}`} className="ms-2">
          <FormattedMessage id="Modules and Conditions" />
        </Link>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IOsComponent);
